export const ROUTES = {
  INTRODUCTION: "/",

  PV_SETUP: "/pv-setup",
  WALLBOX: "/wallbox-setup",
  BATTERY_SETUP: "/battery-setup",
  ANNUAL_GRID_SUPPLY: "/annual-grid-supply",
  SMART_METER: "/smart-meter",
  CALCULATED_SAVINGS: "/calculated-savings",
  TARIF: "/tarif-selection",

  YOUR_NAME: "/your-name",
  CONTACT_INFORMATION: "/contact-information",
  ADDRESS: "/address",
  TECHNICAL_DETAILS: "/technical-details",

  CONTRACT_CHANGE: "/contract-change",
  CURRENT_SUPPLIER: "/current-supplier",
  DATE_OF_CONTRACT_START: "/date-of-contract-start",

  PAYMENT_DETAILS: "/payment-details",
  FEED_IN_OFFER: "/feed-in-offer",
  CONTRACT_SUMMARY: "/contract-summary",

  CONCLUSION: "/conclusion",
  ERROR: "/error",
};

export const DEMO_ROUTES = {
  DEMO: "/b2cdemo/websocket",
};

export const ONBOARDING_ROUTES = {
  ONBOARDING_SYSTEM: "/onboarding/system",
  ONBOARDING_CONNECTED_DEVICES: "/onboarding/connected-devices",
  ONBOARDING_ERROR_RETRY: "/onboarding/error-retry",
};

export const SMART_CHARGING_ROUTES = {
  COMPATIBILITY: "/smart-charging/compatibility/check/",
  MODEL: "/smart-charging/compatibility/check/model",
  MANUFACTURER_SEARCH: "/smart-charging/compatibility/check/other",
  MODEL_SEARCH: "/smart-charging/compatibility/check/other/model",
  STATUS: "/smart-charging/compatibility/check/status",

  TERMS: "/smart-charging/compatibility/terms",
  COMPATIBILITY_SUCCESS: "/smart-charging/compatibility/success",

  ADD_WALLBOX_START: "/smart-charging/add-wallbox/start/",
  INTRO: "/smart-charging/add-wallbox/intro",
  CONNECT_CONFIRM: "/smart-charging/add-wallbox/connect-confirm",
  CONNECTING: "/smart-charging/add-wallbox/connecting",
  CONNECTING_SUCCESS: "/smart-charging/add-wallbox/connecting-success",
  CONNECTING_ERROR: "/smart-charging/add-wallbox/connecting-error",
  ONBOARDING_SLIDER: "/smart-charging/add-wallbox/onboarding-slider",

  ADD_EV_START: "/smart-charging/add-ev/start/",
  ADD_EV_ONBOARDING_CALLBACK: "/smart-charging/add-ev/onboarding-callback",
  ADD_EV_SUCCESS: "/smart-charging/add-ev/success",
  ADD_EV_FAILED: "/smart-charging/add-ev/failed",
};

export const SITE_AUTHENTICATION_ROUTES = {
  START: "/site-authentication/start/",
  SUCCESS: "/site-authentication/success",
  FAILED: "/site-authentication/failed",
  AUTHENTICATION_CALLBACK: "/site-authentication/authentication-callback",
};

export const SELF_ONBOARDING_ROUTES = {
  COMPATIBILITY: "/selfonboarding/compatibility/check/",
  ACCESS: "/selfonboarding/compatibility/access",
  ACCESS_SUCCESS: "/selfonboarding/compatibility/access-success",
  ACCESS_FAILED: "/selfonboarding/compatibility/access-failed",
  AUTHENTICATION_CALLBACK:
    "/selfonboarding/compatibility/authentication-callback",
};
